/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {Embedding} from '../../core/_models'

type Props = {
  embeddings: Embedding
}

const UserInfoCell: FC<Props> = ({embeddings}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-40px overflow-hidden me-3'>
      <a href='#'>
        <div className='symbol-label'>
          <img
            src={toAbsoluteUrl(`/media/avatars/icons8-file-100.png`)}
            alt={embeddings.fileName ?? ''}
            className='w-50'
          />
        </div>
      </a>
    </div>
    <div>
    <div className='d-flex flex-column'>{embeddings.fileName?? ''}</div>
    {/* <div className='d-flex flex-column'>{embeddings.filePath?? ''}</div> */}

</div>    
  </div>
)

export {UserInfoCell}
